<template>
  <div>
    <div v-if="!ready">
      <blank title="No Funds"></blank>
    </div>
    <div v-else>
      <b-form @submit="onSubmit" @reset="onReset">
        <b-card>
          <h2>Card Info</h2>
          <p class="text-muted">
            Save your card securely to IPFS. Sensitive information is encrypted.
          </p>
          <br />
          <b-alert variant="warning" show
            >Double check all numbers and your card balance. Incorrect
            information risks losing your token</b-alert
          >
          <b-row>
            <b-col cols="8">
              <b-form-group
                id="input-group-3"
                label="Card Brand:"
                label-for="input-3"
              >
                <b-form-select
                  id="input-3"
                  v-model="documents.public.brand"
                  :options="$store.state.meta.brands"
                  required
                ></b-form-select>
              </b-form-group>

              <b-form-group
                id="input-group-2"
                label="Card Balance:"
                label-for="input-2"
                description="Must be at least 1 USD. Decimals will be truncated"
              >
                <b-form-input
                  id="input-2"
                  v-model="documents.public.balance"
                  type="number"
                  placeholder="Enter card balance"
                  min="1"
                  max="500"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="input-group-1"
                label="Card Number: "
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model="documents.private.number"
                  ref="number"
                  type="text"
                  placeholder="Enter card number"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="input-group-2"
                label="Card Pin:"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  type="password"
                  v-model="documents.private.pin"
                  placeholder="Enter card pin"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-card bg-variant="light" class="h-100">
                <b-img
                  class="w-100 text-muted"
                  style="border: dashed; border-radius: 5px"
                  :src="logos[documents.public.brand]"
                  v-if="logos[documents.public.brand]"
                ></b-img>
              </b-card>
            </b-col>
          </b-row>
          <br />
          <hr />
          <h2>Collateral</h2>
          <div v-if="true">
            <p class="text-muted">
              You must deposit at least 2x your balance in DAI. You'll earn
              rewards on this money and you can withdraw at any time
            </p>
            <br />
            <b-input-group>
              <b-form-input
                :disabled="loading"
                ref="collateral"
                v-model="collateral"
                :state="collateral >= required"
                type="number"
                min="0.00"
                required
              ></b-form-input>

              <b-input-group-append>
                <b-button
                  :disabled="loading"
                  variant="outline-primary"
                  @click="getDai()"
                  >MAX</b-button
                >
                <b-input-group-text>
                  {{ collateral }} / {{ required }} DAI Required
                </b-input-group-text>
              </b-input-group-append>
            </b-input-group>
            <br />
          </div>
          <hr />
          <h2>Permissions</h2>
          <p class="text-muted">
            As a condition of the marketplace, you must give the marketplace
            contract permissions over your card NFT. If your card loses value,
            the collateral and interest accrued will be taken
          </p>
          <b-form-checkbox
            id="checkbox-1"
            name="checkbox-1"
            required
            v-model="agree"
          >
            I agree to all the terms
          </b-form-checkbox>
          <br />
          <div class="text-right">
            <b-button class="mr-2" variant="primary" v-if="!loading" :disabled="loading" type="submit">Mint Card</b-button>
            <b-button class="mr-2" variant="primary" v-else disabled type="submit"><b-spinner small></b-spinner> Mint Card</b-button>
            <b-button class="mr-2" variant="danger" v-if="!loading" :disabled="loading" type="reset">Reset Form</b-button>
            <b-button class="mr-2" variant="danger" v-else disabled type="reset"><b-spinner small></b-spinner> Reset Form</b-button>
          </div>
        </b-card>
      </b-form>
      <br />
      <br />
    </div>
  </div>
</template>
<script>
import Blank from "@/components/Blank.vue";
export default {
  components: { Blank },
  data() {
    return {
      loading: false,
      logos: {
        Walmart:
          "https://bafkreifhfffutvqpozovd3r47wgvvv5e62qmyygwzxpqdmzcn7dydradey.ipfs.dweb.link/",
      },
      documents: {
        public: {
          brand: "",
          balance: 0,
          image: "",
        },
        private: {
          number: "",
          pin: "",
        },
      },
      collateral: 0,
      agree: true,
    };
  },
  computed: {
    required() {
      return 2 * this.documents.public.balance || 2;
    },
    ready() {
      return this.$store.state.ethereum.ready;
    },
    profile() {
      return this.$store.state.ethereum.profile;
    },
  },
  methods: {
    async onSubmit(event) {
      this.loading = true;
      event.preventDefault();
      try {
        this.documents.public["image"] = this.logos[this.documents.public.brand] || "";
        let publicURL = await this.$store.dispatch(
          "ethereum/savePublicDocument",
          JSON.stringify(this.documents.public)
        );
        // TODO: privateURL
        let id = await this.$store.dispatch("ethereum/createCard", {
          assetToken: this.$store.state.ethereum.constants.token,
          assetAmount: this.collateral,
          url: "https://" + publicURL + ".ipfs.dweb.link",
        });
      } catch (err) {
        this.$bvToast.toast(err["message"] || err, {
          title: "Error",
          variant: "danger",
        });
      } finally {
        this.loading = false;
      }
    },
    onReset(event) {
      event.preventDefault();
      // Reset our form values
      this.documents.public.brand = "";
      this.documents.public.balance =  1;
      this.documents.public.image = "";
      this.documents.private.number = "";
      this.documents.private.pin = "";
      this.collateral = 2;
      this.agree = false;
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    getDai() {
      this.loading = true;
      this.$store
        .dispatch("ethereum/totalDai")
        .then((balance) => {
          this.collateral = balance;
        })
        .catch((err) => {
          this.$bvToast.toast(err["message"] || err, {
            title: "Error",
            variant: "danger",
          });
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>